import React from "react";
import OrdersListItem from "../../OrdersListItem";

const HistoryIndividual = (props) => {
    
    const {
        session,
        orderList,
        handleLike,
        handleDislike,
    } = props;
    const { data, isFetching } = orderList;

    return (
        <ul className="unlimited-block items-list orders-list screen-bottom-block">
            {

                isFetching ?
                <li className="list-item">Загружается...</li>
                :
                    data.results.length
                    ?
                    data.results.map((item, index) => 
                        <OrdersListItem
                            key={index}
                            isLoggedIn={session.isLoggedIn}
                            currentUserId={session.currentUser && session.currentUser.id}
                            handleLike={() => handleLike(item)}
                            handleDislike={() => handleDislike(item)}
                            {...item}
                        />
                    )
                    :
                    <li className="list-item">Заказов нет</li>
            }
        </ul>
    )
}

export default HistoryIndividual;


// WEBPACK FOOTER //
// ./src/components/Profile/SubHistory/HistoryIndividual.js